module.exports = {
    langs: ['en-US', 'zh-CN'],
    defaultLangKey: 'zh-CN'
  };